/* eslint-disable react/sort-comp */
/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import classNames from 'classnames';
import some from 'lodash/some'

import { Button } from 'primereact/button';
import { RadioButton } from 'primereact/radiobutton';
import { Checkbox  } from 'primereact/checkbox';
import { PickList } from 'primereact/picklist';
import { SplitButton } from 'primereact/splitbutton';

import JustificationModal from '@components/JustificationModal';

import { SET_VALUES_DOCUMENT } from '@constants/actionType';
import catalogPermissionsId from '@constants/catalogPermissionsId'

import { getInfoForPreviewDocument } from '@actions/documents';
import { validatePermissionAction } from '@actions/sessionPermission';

import { AuthorizedStatus } from '@constants/general'

import store from '@store';

import './style.scss'

class ObligatoryForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      mandatoryReading: false,
      errors: [],
      workstationSelected: [],
      workstationAvailable: [],
      isAllWorstation: true,
      languagePreview: [],
      currentLanguage: this.props.i18n.language,
      showModalJustification: {
        isVisible: false,
        title: '',
        description: '',
        label: '',
        continueAction: null,
      },
    };

    this.actions = [
      {
        label: this.props.t('Cancelar'),
        command: (e) => {}
      }
      // {
      //   label: this.props.t('Enviar a autorizar'),
      //   icon: 'pi pi-users',
      //   command: (e) => {
      //       this.onSubmit(() => this.props.success())
      //   }
      // },
      // {
      //     label: this.props.t('Autorizar'),
      //     icon: 'pi pi-check-circle',
      //     command: (e) => {
      //       this.onSubmit(() => this.props.authorize())
      //     }
      // }
    ]
  //   this.actionsEdit = [
  //     // {
  //     //   label: this.props.t('Enviar a autorizar'),
  //     //   icon: 'pi pi-users',
  //     //   command: (e) => {
  //     //     this.onSubmit(() => this.props.sendAuthorize())
  //     //   }
  //     // },
  //     // {
  //     //   label: this.props.t('Eliminar versión'),
  //     //   icon: 'pi pi-trash',
  //     //   command: (e) => {
  //     //     this.onSubmit(() => this.props.deleteVersion())
  //     //   }
  //     // },
  //     {
  //         label: this.props.t('Autorizar'),
  //         icon: 'pi pi-check-circle',
  //         command: (e) => {
  //           this.onSubmit(() => this.props.authorize())
  //         }
  //     },
  //     // {
  //     //   label: this.props.t('Rechazar'),
  //     //   icon: 'pi pi-times',
  //     //   command: (e) => {
  //     //     this.onSubmit(() => this.props.reject())
  //     //   }
  //     // },
  //   ]
  }

  componentDidMount() {
    const {
      _obligatory,
      workstationCatalog,
      itemsTabsLenguages,
      t
    } = this.props;
    if (_obligatory) {
      this.setState({
        ..._obligatory
      });
    } else {
      this.setState({workstationAvailable: workstationCatalog})
    }
    const languagePreview = itemsTabsLenguages.map((item) => {
      const label = t('En') + ' ' + item.label.replace(`(${t('Obligatorio')})`, '')
      return {
        label,
        icon: 'pi pi-eye',
        command: () => {
          this.onPreview(`${item.key}`)
        }
      }
    })
    this.setState({ languagePreview })
    this.validateOptionsSlit()
    this.setState({ loadingPage: false });
  }

  validateOptionsSlit = () => {
    const { isEdit, validatePermissionAction, estatus } = this.props
    if (isEdit) {
      // @Editar doc
      if (estatus !== AuthorizedStatus.STATUS_AUTHORIZED) {
        const canDeleteVersion = validatePermissionAction(catalogPermissionsId.ELIMINAR_DOCUMENTO)
        if (canDeleteVersion) {
          this.actions.unshift({
            label: this.props.t('Eliminar Version'),
            icon: 'pi pi-times',
            command: () => {
              this.props.deleteVersion()
            }
          })
        }
        const hasAuthorized = validatePermissionAction(catalogPermissionsId.AUTORIZAR_PUBLICACION_DE_DOCUMENTOS)
        if (hasAuthorized) {
          if (estatus !== AuthorizedStatus.STATUS_REJECTED) {
            this.actions.unshift({
              label: this.props.t('Rechazar'),
              icon: 'pi pi-exclamation-triangle',
              command: () => {
                this.props.reject()
              }
            })
          }
          this.actions.unshift({
            label: this.props.t('Autorizar'),
            icon: 'pi pi-check-circle',
            command: () => {
              this.onSubmit((justification) =>  this.props.authorize(justification))
            }
          })
        } else {
          if (estatus !== AuthorizedStatus.STATUS_PENDING) {
            this.actions.unshift({
              label: this.props.t('Enviar a autorizar'),
              icon: 'pi pi-envelope',
              command: () => {
                this.onSubmit((justification) =>  this.props.sendAuthorize(justification))

              }
            })
          }
        }
      }
    } else {
      // @Nueva doc
      const hasAuthorized = validatePermissionAction(catalogPermissionsId.AUTORIZAR_PUBLICACION_DE_DOCUMENTOS)
      if (hasAuthorized) {
        this.actions.unshift({
          label: this.props.t('Autorizar'),
          icon: 'pi pi-check-circle',
          command: () => {
            this.onSubmit((justification) =>  this.props.authorize(justification))
          }
        })
      } else {
        this.actions.unshift({
          label: this.props.t('Enviar a autorizar'),
          icon: 'pi pi-envelope',
          command: () => {
            this.onSubmit((justification) =>  this.props.sendAuthorize(justification))
          }
        })
      }
    }
  }

  componentDidUpdate () {
    if (this.state.currentLanguage !== this.props.i18n.language) {
      const newWorkstationAvailable = this.state.workstationAvailable.map(item => {
        const findNewWork = this.props.workstationCatalog.find(work => work.id === item.id )
        return findNewWork
      })
      const newWorkstationSelected = this.state.workstationSelected.map(item => {
        const findNewWork = this.props.workstationCatalog.find(work  => work.id === item.id )
        return findNewWork
      })
      this.setState({
        currentLanguage: this.props.i18n.language,
        workstationSelected: newWorkstationSelected,
        workstationAvailable: newWorkstationAvailable,
      })
    }
  }

  onPreview = async (language) => {
    console.log('language', language)
    const { getInfoForPreviewDocument } = this.props
    getInfoForPreviewDocument(language)
  };

  onChangeCheckbox = (e) => {
    this.setState({[e.target.name]: e.checked});
  };

  onChange = ({target}) => {
    this.setState({[target.name]: target.value}, () => this.validateFieldsOnchange(target.name, target.value));
  };

  onChangeSimple = ({ target }) => {
    if (target.name === 'isAllWorstation' && target.value) this.setState({ workstationAvailable: this.props.workstationCatalog, workstationSelected: [] })
    this.setState({ [target.name]: target.value }, this.validateFieldsOnchange(target.name, target.value));
  };

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state
    if (errors[name] && value) {
      delete errors[name]
      this.setState({errors})
    }
  }

  validateFields = async () => {
    const { t } = this.props
    const { workstationSelected, isAllWorstation } = this.state
    let errors = {}
    if (!isAllWorstation && !workstationSelected.length) errors = {...errors, [`componentsSelected`]: `${t('Debés seleccionar un componente disponible')}`}
    this.setState({errors})
    return errors
  }

  onSubmit = async (onAction) => {
    // e.preventDefault();
    const validate = await this.validateFields()
    if (some(validate, {})) return true
    const { t } = this.props;
    const { mandatoryReading, workstationAvailable, workstationSelected, isAllWorstation } = this.state;

    await store.dispatch({
      type: SET_VALUES_DOCUMENT,
      payload: { obligatory: {
        mandatoryReading,
        workstationAvailable,
        workstationSelected,
        isAllWorstation
      } },
    });

    this.setState({
      showModalJustification: {
        isVisible: true,
        title: t('CONFIRMACIÓN'),
        description: t('¿Esta seguro que desea hacer este cambio?'),
        label: t('Justificación del cambio'),
        continueAction: ({justification}) => onAction(justification),
      },
    });
  };

  onChangeComponent = (event) => {
    if (this.state.isAllWorstation) return true
    this.setState({
      workstationAvailable: event.source,
      workstationSelected: event.target,
    }, () => this.validateFieldsOnchange('componentsSelected', event.target));
  };

  itemTemplate = (item) => (
      <div className={`product-item p-d-flex `}>
        <div className="product-list-detail">
          <h5 className="p-mb-2">{item.label}</h5>
        </div>
      </div>
    );

  render() {
    const { t, btnSubmitLoading, onBack, success, isEdit, keysLenguages } = this.props;
    const {
      loadingPage,
      errors,
      mandatoryReading,
      workstationAvailable,
      workstationSelected,
      isAllWorstation,
      languagePreview,
      showModalJustification
    } = this.state;

    const isFormFieldValid = (name) =>
      !!(errors[name]);
    const getFormErrorMessage = (name) =>
      isFormFieldValid(name) && (
        <small className="p-error">{errors[name]}</small>
      );

    if (loadingPage) return true;
    return (
      <>
        <div className="p-grid p-justify-end">
            <div className="p-col-12 footer-btn p-mb-4 p-mt-4">
              <div className="p-d-flex p-jc-between">
                <Button
                  label={t('Regresar')}
                  type="button"
                  className="p-button-secondary"
                  onClick={() => onBack()}
                />
                {/* <SplitButton
                  label={t('Vista Previa')}
                  icon="pi pi-eye"
                  onClick={() => this.onPreview(keysLenguages[0])}
                  className="p-button-info"
                  model={languagePreview}
                /> */}
                <SplitButton label={t('Guardar')} icon="pi pi-save" onClick={() => this.onSubmit((justification) => success(justification))} model={this.actions}/>
              </div>
            </div>
          </div>
        {/* <form onSubmit={this.onSubmit} autoComplete="false"> */}
          <div className="p-fluid p-grid p-mb-4">
            <div className="p-col-12 p-field">
              <div className="p-field-radiobutton">
                <Checkbox
                  name="mandatoryReading"
                  value
                  onChange={this.onChangeCheckbox}
                  checked={mandatoryReading}
                />
                <label className="p-text-bold">{t('El documento es de lectura obligatoria para los siguientes puestos')}</label>
              </div>
              <label>{t('Esto no impide que puedan navegar dentro del micrositio')}</label>
            </div>
            <div className="p-col-12 p-field">
              <div className="p-field-radiobutton">
                <RadioButton
                  inputId="isAllWorstation1"
                  name="isAllWorstation"
                  value
                  onChange={this.onChangeSimple}
                  checked={isAllWorstation}
                />
                <label>{t('Todos')}</label>
              </div>
              <div className="p-field-radiobutton">
                <RadioButton
                  inputId="isAllWorstation2"
                  name="isAllWorstation"
                  value={false}
                  onChange={this.onChangeSimple}
                  checked={!isAllWorstation}
                />
                <label>{t('Solo algunos puestos')}</label>
              </div>
                {/* { renderWorstationOption() } */}
              <div className={`${isAllWorstation ? 'disabled-pickLis' : ''}`}>
                <PickList
                  source={workstationAvailable}
                  target={workstationSelected}
                  itemTemplate={this.itemTemplate}
                  // sourceHeader={t('Componentes Disponibles')}
                  // targetHeader={t('Componentes Seleccionados')}
                  sourceStyle={{ height: '642px' }}
                  targetStyle={{ height: '642px' }}
                  onChange={this.onChangeComponent}

                  className={classNames({
                    'p-invalid': isFormFieldValid(`componentsSelected`),
                  })}
                />
                {getFormErrorMessage(`componentsSelected`)}
              </div>
            </div>
          </div>
          {/* <div className="p-col-12 footer-btn">
            <div className="p-d-flex p-jc-between">
              <Button
                label={t('Regresar')}
                type="button"
                className="p-button-secondary"
                onClick={() => onBack()}
              />
              <Button
                label={t('Continuar')}
                type="submit"
                className="p-button-primary"
                loading={btnSubmitLoading}
              />
            </div>
          </div>
        </form>
          */}
        <JustificationModal
          display={showModalJustification.isVisible}
          title={showModalJustification.title}
          description={showModalJustification.description}
          label={showModalJustification.label}
          onHidden={() => this.setState({showModalJustification: { isVisible: false }})}
          onContinueAction={showModalJustification.continueAction}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  _obligatory: state.document.obligatory,
  workstationCatalog: state.catalogs.workstationsCurrentCatalog,
  keysLenguages: state.catalogs.keysLanguageCatalog,
  itemsTabsLenguages: state.catalogs.tabsLanguageCatalog,
  estatus: state.document.estatus
});

const mapDispatchToProps = {
  getInfoForPreviewDocument,
  validatePermissionAction
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(ObligatoryForm);
